import { render, staticRenderFns } from "./SafetyList.vue?vue&type=template&id=16c7025d"
import script from "./SafetyList.vue?vue&type=script&lang=js"
export * from "./SafetyList.vue?vue&type=script&lang=js"
import style0 from "./SafetyList.vue?vue&type=style&index=0&id=16c7025d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports